import { html, Component } from 'htm/preact';

import * as Tracking from '../tracking';

import ShareButton from './ShareButton';
import { generateGuessEmoji, CURRENT_GAME_CONTEXT_ID } from '../utils/game';
import { formatCurrency } from '../utils/intl';

const generateGuessString = (guessList, answer) =>
  guessList.map(guess => generateGuessEmoji(guess, answer)).join('');

export default class GameOver extends Component {
  constructor(props) {
    super(props);
  }

  render({ clientState, serverState, showGuessHistory }) {
    const { gameOver, guessed, guessHistory, id } = clientState;
    const { salePrice } = serverState.listing;

    let gameOverMessage;
    if (guessed && guessHistory.length === 1) {
      gameOverMessage = 'Phenomenal!';
    } else if (guessed && guessHistory.length < 5) {
      gameOverMessage = 'Impressive!';
    } else if (guessed) {
      gameOverMessage = 'Persistent!';
    }

    const guessString =
      generateGuessString(guessHistory, salePrice) + ((gameOver && !guessed && '❌') || '');

    const guessesPlural = guessHistory.length === 1 ? '1 guess' : `${guessHistory.length} guesses`;

    return html`
      <div class="game-over">
        <div class="game-over__reveal">
          Sold for:
          <b>${' ' + formatCurrency(salePrice)}.${' '}</b>
        </div>
        <div class="game-over__results">
          ${guessed
            ? html`
                ${gameOverMessage}${' '} You got Listed in${' '}
                <a class="game-over__guess-number" onclick=${showGuessHistory}>${guessesPlural}</a>
                .
              `
            : html`
                <a class="game-over__guess-number" onclick=${showGuessHistory}>Out of Guesses</a>
                ${' '}— try again tomorrow!
              `}
        </div>

        <div class="game-over__actions">
          <${ShareButton}
            id=${id}
            guessString=${guessString}
            guessHistory=${guessHistory}
            guessed=${guessed}
          />
          <a
            class="listed-button listed-button--support-us"
            href="/archive/${CURRENT_GAME_CONTEXT_ID}/random"
            target="_blank"
            onClick=${() => Tracking.clickKofi()}
          >
            Another Game
          </a>
        </div>
      </div>
    `;
  }
}
